import React, {Component} from 'react';
import {
    TopButtonAction
} from "../../../../componentsTopsa/buttons/TopButtons";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import ReactNotify from 'react-notify';
import PrzegladarkaService from "../PrzegladarkaService";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import {saveAs} from "file-saver";
import OthersUtilities from "../../../../utilities/othersUtilities/OthersUtilities";
import DownloadUtilities from "../../../../utilities/DownloadUtilities";

export default class PrzegladarkaTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal:false,
            setLoader:false,
            czyBladPobierania:false,
            plikDane:null
        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextprops) {
    }

    renderButtonyAkcji(cell, row) {
        if (Boolean(row.typ)) {
            return (
                <div>
                    {
                        (row.typ.indexOf('image') > -1) ?
                            <TopButtonAction btnColor={'default'} block={true}
                                             elementStyle={{color: '#444'}}
                                             text={'Zobacz'} iconType={'fa fa-image'}
                                             onClick={() => this.onClickZobaczObraz(row)}

                            />
                            :
                            <TopButtonAction btnColor={'default'} block={true}
                                             elementStyle={{color: 'dodgerblue'}}
                                             text={'Pobierz'} iconType={'fa fa-download'}
                                             onClick={() => this.pobierzPlikZRest(row)}

                            />
                    }

                </div>
            )
        } else {
            return (
                <div>

                    <TopButtonAction btnColor={'default'} block={true}
                                     elementStyle={{color: 'dodgerblue'}}
                                     text={'Pobierz'} iconType={'fa fa-download'}
                                     onClick={() => this.pobierzPlikZRest(row)}

                    />
                </div>)
        }
    }

    pobierzPlikZRest(plik){
        PrzegladarkaService.pobierzPlikPoId(plik.id).then(function (response) {
            if(response.status<300){
                DownloadUtilities.pobierzPlik(response.data.dane, response.data.typ,response.data.nazwa)
            }
            else{
                alert('Nie można pobrac pliku!')
            }
        }.bind(this)).catch(err=>{
            alert('Nie można pobrac pliku!')
        })
    }

    onClickZobaczObraz(obj){
        this.setState({showModal:true, setLoader:true, plikDane:null,czyBladPobierania:false})
        PrzegladarkaService.pobierzPlikPoId(obj.id).then(function (response) {
            if(response.status<300){
                this.setState({
                    setLoader:false,
                    plikDane:response.data
                })
            }else{
                this.setState({
                    setLoader:false,
                    czyBladPobierania:true
                })
            }
        }.bind(this)).catch(err=>{
            this.setState({
                setLoader:false,
                czyBladPobierania:true
            })
        })
    }

    formatTyp(cell,row){
        return <div>
            <i className={OthersUtilities.renderFileIcon(cell)} style={{marginRight:'5px'}}></i> <span>{cell}</span>
        </div>
    }

    formatRozmiar(cell,row){
        let i = Math.floor( Math.log(cell) / Math.log(1024) );
        return ( cell / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    hover
                    >
                        <TableHeaderColumn dataField='id' isKey hidden={true} thStyle={tabgrid.tg1}
                                           tdStyle={tabgrid.tg1}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                        >ID
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='dokumentTyp' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'SelectFilter', options: this.props.typyPlikow, selectText: '', condition:'eq'}} formatExtraData={this.props.typyPlikow}
                        >Typ dokumentu</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa' dataSort
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Nazwa</TableHeaderColumn>
                        <TableHeaderColumn dataField='typ' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell,row)=>this.formatTyp(cell,row)}
                        >Typ</TableHeaderColumn>
                        <TableHeaderColumn dataField='rozmiar' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatRozmiar}
                        >Rozmiar</TableHeaderColumn>
                        <TableHeaderColumn dataField='katalog' dataSort
                                           thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Katalog</TableHeaderColumn>
                        <TableHeaderColumn dataField='dataWpisu' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Data wpisu</TableHeaderColumn>
                        <TableHeaderColumn dataField='id'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           dataFormat={this.renderButtonyAkcji}
                        >Zobacz lub pobierz</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                {
                    (this.state.showModal) ?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'} style={{margin:'10vh auto auto auto'}}>
                                <div id={'modalTextContent'} style={{width: '500px'}}>
                                    <div>
                                        <div className={'pull-left'}>
                                            <div style={{marginTop:'4px'}}>
                                            {
                                                Boolean(this.state.plikDane)?
                                                    <span className={'label label-ebus-primary'} style={{fontSize:'16px'}}>{this.state.plikDane.dokumentTyp}</span>
                                                    :
                                                    ''
                                            }
                                            </div>
                                        </div>
                                        <div className={'pull-right'}>
                                            <TopButtonAction onClick={() => {
                                                this.setState({showModal: false})
                                            }}
                                                             elementStyle={{color: 'firebrick'}}
                                                             btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                            />
                                        </div>
                                        <div style={{clear: 'both'}}></div>
                                        <div>

                                            {
                                                (this.state.setLoader)?
                                                    <div id={'simple-small-loader'}>
                                                        <i className={'fa fa-spinner fa-spin'}></i>
                                                    </div>
                                                    :
                                                    <div>
                                                        {
                                                            (this.state.czyBladPobierania)?
                                                                <TopAlertUwaga text={'Błąd pobierania pliku!'}/>
                                                                :
                                                                <div style={{padding:'5px', maxWidth:'450px'}}>
                                                                    <h4 style={{marginBottom:'25px', lineHeight:'1.1'}}>
                                                                         {this.state.plikDane.nazwa}
                                                                    </h4>
                                                                    <img src={'data:image/jpg;base64,' + this.state.plikDane.dane} className={'img-responsive'} style={{maxHeight:'500px', display:'block',margin:'0 auto'}}/>
                                                                </div>
                                                        }
                                                    </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        :
                        ''
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/przegladarka_plikow/components/PrzegladarkaTable.js